import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetDocumentListTktRequest,
  failGetDocumentListTkt,
  setGetDocumentListTkt,
  setGetDocumentListTktFromApi,
  updateGetDocumentListTkt,
  updateGetDocumentListTktFromApi,
} from './get-document-list-tkt.actions';

/**
 * Service to handle async GetDocumentListTkt actions
 */
@Injectable()
export class GetDocumentListTktEffect {
  /**
   * Set the state with the reply content, dispatch failGetDocumentListTkt if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetDocumentListTktFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetDocumentListTkt({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetDocumentListTkt({ error, requestId: action.requestId })),
        cancelGetDocumentListTktRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetDocumentListTkt if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetDocumentListTktFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetDocumentListTkt({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetDocumentListTkt({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
